import { Button } from '@cropler/ui-kit';

import styles from './styles.module.scss';

const EmptyViewCustomCharts = ({ t, clickCreate }) => {
  const onClickCreate = () => {
    clickCreate();
  };

  return (
    <div className={`${styles.emptyView} container`}>
      <svg xmlns="http://www.w3.org/2000/svg" width="85" height="84" viewBox="0 0 84 84" fill="none">
        <path
          fill="#eeeff0"
          d="M48.1814 38.855h31.8333c2.8972 0 5.1932-2.4427 4.9702-5.3011-.6747-8.6496-4.4753-16.8017-10.7017-22.9547C68.0571 4.44606 59.808.690176 51.0553.0234257 48.1656-.195434 45.6912 2.06814 45.6912 4.93497V36.3939c0 1.3593 1.1149 2.4611 2.4902 2.4611"
        />
        <path
          fill="#e3e4e5"
          d="M80.0147 43.7986H48.1806c-2.1981 0-3.3144 2.6184-1.7879 4.1741l22.161 22.5835c2.0207 2.0593 5.3898 1.9847 7.3065-.16 5.3488-5.9858 8.504-13.3487 9.1244-21.2925.2236-2.858-2.0689-5.3051-4.9699-5.3051"
        />
        <path
          fill="#eeeff0"
          d="M39.4042 48.9596V16.0524c0-2.8673-2.478-5.1317-5.3781-4.9105-9.1416.6997-17.6533 4.727-23.9665 11.3398C3.71929 29.1231.14846 37.8066.00469074 46.9329-.148874 56.6748 3.57336 65.9071 10.4856 72.9288c6.9061 7.0153 16.1316 10.9431 25.9768 11.0596.1526.0018.305.0028.4572.0028 7.8965 0 15.4179-2.425 21.7784-7.0268 2.4288-1.7568 2.7429-5.2295.6611-7.3812z"
        />
      </svg>

      <h1 className={`${styles.emptyViewTitle} h1`}>{t('charts.custom.title')}</h1>
      <p>{t('charts.custom.text')}</p>

      <div className={styles.emptyViewNav}>
        <Button type="primary" onClick={onClickCreate}>
          {t('charts.custom.createTitle')}
        </Button>
      </div>
    </div>
  );
};

export default EmptyViewCustomCharts;
